<h2 mat-dialog-title>
  {{ (isUpdateMode ? "inspectionUpsertDialog.isUpdateModeInformation" : "inspectionUpsertDialog.isUpdateModeAddInspection") | translate }}
</h2>
<mat-dialog-content class="form-container" fxLayout="row" fxLayoutAlign="center start">
  <div class="form-contents" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="title-div" fxFlex>
        <mat-form-field class="title-form" fxFlex>
          <mat-label class="top-label">{{ getPlaceholder("inspectionUpsertDialog.titlePlaceholder" | translate) }}</mat-label>
          <input
            data-testid="inspection-title"
            [formControl]="inspectionTitleForm"
            [readonly]="isEditableName && !isUpdateMode"
            matInput
            maxlength="100"
            required
            (keyup)="onKeyUpHandleInspectionName()"
          />
          <mat-icon
            *ngIf="spaceValidator() || dotValidator()"
            [matTooltip]="'inspectionUpsertDialog.titleAutoRemoved' | translate"
            class="material-icons-outlined"
            matSuffix
            matTooltipClass="tooltip-inner"
            matTooltipPosition="above"
            matTooltipPositionAtOrigin="true"
            >info
          </mat-icon>
          <mat-hint align="end">{{ inspectionTitleForm.value?.length || 0 }}/100</mat-hint>
          <mat-error *ngIf="inspectionTitleForm.hasError('required')">{{ "inspectionUpsertDialog.titleRequiredError" | translate }} </mat-error>
          <mat-error *ngIf="inspectionTitleForm.hasError('maxlength')">{{ "inspectionUpsertDialog.titleMaxlengthError" | translate }} </mat-error>
          <mat-error *ngIf="inspectionTitleForm.hasError('regex') && !inspectionTitleForm.hasError('required')">
            <ng-container *ngIf="isContainInvalidCharInSN">
              {{ "inspectionUpsertDialog.titleContainKanjiRegexError" | translate: { serialNumber: serialNumberLabel } }} {{ regularExpressionStr }}
            </ng-container>
            <ng-container *ngIf="!isContainInvalidCharInSN">
              {{ "inspectionUpsertDialog.titleRegexError" | translate }} {{ regularExpressionStr }}
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="40px">
      <mat-form-field fxFlex>
        <mat-label class="top-label">{{ getPlaceholder(serialNumberLabel, false, true) }}</mat-label>
        <mat-select
          (openedChange)="openChangeSelect($event)"
          (selectionChange)="loadInspectionName()"
          [compareWith]="compareWithFn"
          [formControl]="subjectForm"
          hideSingleSelectionIndicator
          panelClass="search-combo-select"
          required
        >
          <mat-select-trigger>
            {{ subjectForm.value?.subject?.serialNo }}
          </mat-select-trigger>
          <div class="select-over-lay">
            <input #searchInput (keyup)="subjectFiltering($event.target.value)" autocomplete="off" class="subject-search-input" matInput />

            <div class="options-content">
              <ng-container *ngFor="let subjectModel of subjectModels; trackBy: trackBySubjectModel">
                <ng-container *ngIf="groupedSubjects[subjectModel.id]?.length">
                  <mat-optgroup [label]="subjectModel.name">
                    <mat-option
                      *ngFor="let subjectWrapper of groupedSubjects[subjectModel.id]; trackBy: trackBySubjectWrapper"
                      [value]="subjectWrapper"
                    >
                      <div class="serial-chip-list">
                        <div [class.has-attributes]="subjectWrapper.attributes.length > 0" class="serial-div">
                          <span
                            [matTooltip]="subjectWrapper.subject.serialNo"
                            class="serial-span"
                            matTooltipClass="tooltip-overflow"
                            matTooltipPosition="above"
                          >
                            {{ subjectWrapper.subject.serialNo }}
                          </span>
                        </div>

                        <ng-container *ngFor="let attr of subjectWrapper.attributes; index as i">
                          <div
                            *ngIf="attr && !subjectWrapper.removed && i < 2"
                            [matTooltip]="attr"
                            class="attributes-div"
                            matTooltipClass="tooltip-overflow"
                            matTooltipPosition="above"
                          >
                            <span class="attributes-span">{{ attr }}</span>
                          </div>
                        </ng-container>

                        <div
                          *ngIf="!subjectWrapper.removed && subjectWrapper.attributes.length > 2"
                          [matTooltip]="subjectWrapper.etcAttributesLabel"
                          class="attributes-div"
                          matTooltipClass="tooltip-overflow"
                          matTooltipPosition="above"
                        >
                          <span class="attributes-span">...</span>
                        </div>

                        <span *ngIf="subjectWrapper.removed">
                          {{ "inspectionUpsertDialog.removed" | translate }}
                        </span>
                      </div>
                    </mat-option>
                  </mat-optgroup>
                </ng-container>
              </ng-container>
              <mat-option *ngIf="filteredSubjects?.length < 1" disabled>
                {{ serialNumberLabel }} {{ "inspectionUpsertDialog.snNotFound" | translate }}
              </mat-option>
            </div>
          </div>
        </mat-select>
        <mat-error *ngIf="subjectForm.hasError('required')"
          >{{ serialNumberLabel }} {{ "inspectionUpsertDialog.subjectRequiredError" | translate }}
        </mat-error>
      </mat-form-field>
      <button (click)="createSubject()" [style.visibility]="!subjectForm.disabled && !isOffline ? 'visible' : 'hidden'" color="primary" mat-mini-fab>
        <mat-icon aria-label="">add</mat-icon>
      </button>
    </div>
    <div class="template-version-label">{{ "inspectionUpsertDialog.versionLabel" | translate }} {{ getTemplateVersion() }}</div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="32px">
      <div class="subject-attribute-label">
        {{ "inspectionUpsertDialog.attributesVersionLabel" | translate }} {{ getAttributesVersion() }}
        <ng-container *ngIf="isUpdateMode">{{ "inspectionUpsertDialog.readonly" | translate }}</ng-container>
      </div>
      <button
        (click)="onClickEditAttributes()"
        *ngIf="!isDesktop && !isUpdateMode && visibleAttrExists"
        [disabled]="!subjectForm.value"
        color="primary"
        mat-raised-button
      >
        {{ "inspectionUpsertDialog.edit" | translate }}
      </button>
    </div>
    <ng-container *ngIf="hasSubjectAttributes()">
      <mat-list class="subject-attribute-list" role="list">
        <mat-list-item *ngIf="isShowOwner && subjectForm.value.subject.owner" class="subject-attribute" role="listitem">
          <span matListItemLine>{{ ownerLabel }} : {{ subjectForm.value.subject.owner }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="isShowCountry && subjectForm.value.subject.country" class="subject-attribute" role="listitem">
          <span matListItemLine>{{ countryLabel }} : {{ subjectForm.value.subject.country }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="isShowState && subjectForm.value.subject.state" class="subject-attribute" role="listitem">
          <span matListItemLine>{{ stateLabel }} : {{ subjectForm.value.subject.state }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="isShowDistrict && subjectForm.value.subject.district" class="subject-attribute" role="listitem">
          <span matListItemLine>{{ districtLabel }} : {{ subjectForm.value.subject.district }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="isShowSite && subjectForm.value.subject.site" class="subject-attribute" role="listitem">
          <span matListItemLine>{{ siteLabel }} : {{ subjectForm.value.subject.site }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="isShowProject && subjectForm.value.subject.project" class="subject-attribute" role="listitem">
          <span matListItemLine>{{ projectLabel }} : {{ subjectForm.value.subject.project }}</span>
        </mat-list-item>
      </mat-list>
    </ng-container>

    <mat-form-field class="datepicker">
      <mat-label class="top-label">{{ getPlaceholder("inspectionUpsertDialog.inspectionDatePlaceholder" | translate) }}</mat-label>
      <input
        (dateChange)="loadInspectionName()"
        [formControl]="inspectionDateForm"
        [matDatepicker]="picker"
        [max]="maxDate"
        [min]="minDate"
        matInput
        required
      />
      <mat-datepicker-toggle [for]="picker" matSuffix>
        <mat-icon class="datepicker-icon" matDatepickerToggleIcon>today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #picker touchUi></mat-datepicker>
      <mat-error *ngIf="inspectionDateForm.hasError('required')">{{ "inspectionUpsertDialog.inspectionDateRequiredError" | translate }} </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!isOnPremise">
      <mat-label class="top-label">{{ getPlaceholder("inspectionUpsertDialog.inspectorsPlaceholder" | translate) }}</mat-label>
      <mat-select #inspectors (selectionChange)="loadInspectionName()" [formControl]="inspectorsForm" multiple required>
        <mat-select-trigger>
          {{ inspectorsForm.value?.length > 0 ? getSortedInspectors()[0]?.name : "" }}
          <span *ngIf="inspectorsForm.value && inspectorsForm.value.length > 1">
            (+{{ inspectorsForm.value.length - 1 }} {{ "inspectionUpsertDialog.others" | translate }})
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let inspector of selectableInspectors" [value]="inspector">
          {{ inspector.name ? inspector.name : ("inspectionUpsertDialog.unknownUser" | translate) }}
          <span *ngIf="!inspector.inspector.isActive"> {{ "inspectionUpsertDialog.removed" | translate }} </span>
          <span *ngIf="!inspector.inspector.isSubscription && inspector.inspector.isActive">
            {{ "inspectionUpsertDialog.noSubscription" | translate }}</span
          >
        </mat-option>
      </mat-select>
      <mat-error *ngIf="inspectorsForm.hasError('required')">{{ "inspectionUpsertDialog.inspectorRequiredError" | translate }} </mat-error>
    </mat-form-field>

    <ng-container *ngIf="isUpdateMode && !isBrianMode">
      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <div class="download">
          <h3 class="headline">{{ "inspectionUpsertDialog.downloadHeadline" | translate }}</h3>
          <h5 class="message">
            {{
              "inspectionUpsertDialog.downloadMessage"
                | translate
                  : {
                      lowerCaseMarkLabel: lowerCaseMarkLabel,
                      lowerCaseTitleLabel: lowerCaseTitleLabel
                    }
            }}
          </h5>
          <button data-testid="download-btn" (click)="downloadStructure()" [disabled]="dowloadingStructure" color="primary" mat-raised-button>
            <mat-icon aria-label="">file_download</mat-icon>
            {{ "inspectionUpsertDialog.download" | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="isDeviceConnectMode" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <div class="download">
          <h3 class="headline">{{ "inspectionUpsertDialog.sendData" | translate }}</h3>
          <h5 class="message">
            {{
              "inspectionUpsertDialog.includesInspFolders"
                | translate
                  : {
                      lowerCaseMarkLabel: lowerCaseMarkLabel,
                      lowerCaseTitleLabel: lowerCaseTitleLabel
                    }
            }}
          </h5>
          <button (click)="sendDataForIplexDevice()" color="primary" mat-raised-button>
            <mat-icon aria-label="">upload</mat-icon>
            {{ "inspectionUpsertDialog.send" | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutGap="10px">
  <div fxFlex fxLayout="row" fxLayoutAlign="center">
    <button class="cancel-button" [mat-dialog-close]="true" color="primary" mat-button>
      {{ "inspectionUpsertDialog.cancel" | translate }}
    </button>
    <button
      (click)="submit()"
      [disabled]="
        inspectionTitleForm.invalid ||
        subjectForm.invalid ||
        inspectionDateForm.invalid ||
        inspectorsForm.invalid ||
        inspectorsForm.disabled ||
        !this.inspectionTitleForm.value ||
        isProcess ||
        isReadOnly()
      "
      color="primary"
      mat-raised-button
    >
      {{ "inspectionUpsertDialog.save" | translate }}
    </button>
  </div>
  <button class="delete-button" (click)="delete()" *ngIf="isUpdateMode" [disabled]="!this.inspection || isReadOnly()" color="warn" mat-raised-button>
    {{ "inspectionUpsertDialog.delete" | translate }}
  </button>
</mat-dialog-actions>
